export default {
    rei_250: 'Amputation of lower limbs, bilateral',
    rei_251: 'Lower airway burns',
    rei_252: 'Dislocation of hip',
    rei_253: 'Dislocation of knee',
    rei_254: 'Dislocation of shoulder',
    rei_255: 'Muscle and tendon injuries, including sprains and strains lesser dislocations',
    rei_256: 'Fracture of clavicle, scapula, or humerus',
    rei_257: 'Fracture of face bones',
    rei_258: 'Fracture of foot bones except ankle',
    rei_259: 'Fracture of hand (wrist and other distal part of hand)',
    rei_260: 'Fracture of hip',
    rei_261: 'Amputation of upper limbs, bilateral',
    rei_262: 'Fracture of patella, tibia or fibula, or ankle',
    rei_263: 'Fracture of pelvis',
    rei_264: 'Fracture of radius and/or ulna',
    rei_265: 'Fracture of skull',
    rei_266: 'Fracture of sternum and/or fracture of one or more ribs',
    rei_267: 'Fracture of vertebral column',
    rei_268: 'Fracture of femur, other than femoral neck',
    rei_269: 'Minor TBI',
    rei_270: 'Moderate/Severe TBI',
    rei_272: 'Amputation of fingers (excluding thumb)',
    rei_273: 'Foreign body in ear',
    rei_274: 'Foreign body in respiratory system',
    rei_275: 'Foreign body in GI and urogenital system',
    rei_276: 'Spinal cord lesion at neck level',
    rei_277: 'Spinal cord lesion below neck level',
    rei_278: 'Drowning and nonfatal submersion',
    rei_279: 'Asphyxiation',
    rei_280: 'Crush injury',
    rei_281: 'Nerve injury',
    rei_282: 'Injury to eyes',
    rei_283: 'Amputation of lower limb, unilateral',
    rei_284: 'Open wound(s)',
    rei_285: 'Poisoning requiring urgent care',
    rei_286: 'Severe chest Injury',
    rei_287: 'Internal hemorrhage in abdomen and pelvis',
    rei_288: 'Contusion in any part of the body',
    rei_289: 'Effect of different environmental factors',
    rei_290: 'Complications following therapeutic procedures',
    rei_291: 'Superficial injury of any part of the body',
    rei_292: 'Multiple fractures, dislocations, crashes, wounds, pains, and strains',
    rei_293: 'Amputation of upper limb, unilateral',
    rei_294: 'Amputation of thumb',
    rei_295: 'Amputation of toe/toes',
    rei_296: 'Burns, <20% total burned surface area without lower airway burns',
    rei_297:
        'Burns, >=20% total burned surface area or >= 10% burned surface area if head/neck or hands/wrist involved w/o lower airway burns',
    rei_298: 'Amputations',
    rei_299: 'Burns',
    rei_300: 'Fractures',
    rei_301: 'Head Injuries',
    rei_302: 'Spinal Injuries',
    rei_303: 'Minor Injuries',
    rei_304: 'Other Injuries',
};
